import { useTheme } from '@context/ThemeContext';
import { Layout, Typography } from 'antd';

const { Footer: AntFooter } = Layout;
const { Text } = Typography;

const Footer = () => {
  const { colors } = useTheme();
  return (
    <AntFooter style={{ textAlign: 'center', padding: '12px 24px', background: colors.bg_500 }}>
      <Text style={{ color: colors.text_400 }} type="secondary">
        © {new Date().getFullYear()} Bundle Drop — Intraface
      </Text>
    </AntFooter>
  );
};

export default Footer;
